export default "__VITE_ASSET__Cg206CUR__"